/** Reality check main map */
<!--suppress HtmlUnknownTarget -->

<template>
    <div class="main-map-container">
        <div id="main-map"></div>

        <div class="map-controls">
            <a><button class="rc-menu-button active">Map</button></a>
            <a href="/stats/"><button class="rc-menu-button">Statistics</button></a>
            <a href="/history/"><button class="rc-menu-button">History</button></a>
            <a href="/info/"><button class="rc-menu-button">Information</button></a>
<!--            <a v-bind:href="browserLink"><button class="rc-menu-button">MPA browser</button></a>-->

            <div class="mobile-logos-in-map-controls">
                <a href="https://mcsuk.org">
                    <svg aria-hidden="true" focusable="false">
                        <use href="#mcs-logo"></use>
                    </svg>
                </a>
                <a class="" target="_blank" href="https://www.wildlifetrusts.org/">
                    <img class="" src="/static/img/TWT_LOGO_PRIMARY_COLOUR.SVG.svg" alt="The Wildlife Trusts">
                </a>
                <a target="_blank" href="https://www.bluemarinefoundation.com">
                    <img src="/static/img/BMF_Logo_CMYK_Blue.svg" alt="Blue Marine Foundation">
                </a>
            </div>


        </div>

        <div class="main-map-overlay" v-if="showLoadingOverlay">
            <div>
                <h4>{{ loadingOverlayText }}</h4>
                <div class="overlay-spinner">
                    <div class="s-r1"></div><div class="s-r2"></div><div class="s-r3"></div><div class="s-r4"></div><div class="s-r5"></div>
                </div>
            </div>
        </div>

        <modal size="medium" vertical-position="top" v-if="showDetailsModal" v-on:close="showDetailsModal = false; showConditionDetails = false; detailsTitle = ''; detailsContent = ''; detailsShowChart = false">
            <div slot="header">
                <h3>{{ detailsTitle }}</h3>
            </div>

            <div slot="body" class="details-content">
                <div v-if="!showConditionDetails">
                    <div v-html="detailsContent"></div>
                    <div v-html="conditionLeader" v-on:click.prevent="showConditionDetails = true" style="cursor: pointer"></div>
                    <div v-if="!is_byelaw">
                        <hr>
                        <div v-if="detailsShowChart" class="popupFishingDataChart"></div>
                        <div v-if="!detailsShowChart">No fishing data available.</div>
                    </div>
                </div>

                <div v-if="showConditionDetails">
                    <div v-html="conditionReport"></div>
                    <hr>
                    <feature-tabs v-bind:features="conditionFeatures"/>
                </div>
            </div>
        </modal>
    </div>
</template>


<script>
import Vue from "vue";
import store from "./store/reality-check-store.js";
import L from "leaflet";
import * as esri from "esri-leaflet";
const axios = require("axios");


import { MapBoxBackgroundMapping } from "../../js/map-layers.js";
import { createOffsetTopPlaceholders, reduceLatLngPrecision } from "../../js/map-tools.js";
import Modal from "../common-components/modal.vue";
import MainMapQueryContent from "./main-map-query-content.vue";
import FeatureTabs from "./recovery-check-features-tabs.vue";


export default {
    name: "main-map",
    components: {
        Modal, MainMapQueryContent, FeatureTabs
    },
    store,
    props: {},
    data: function () {
        return {
            showLoadingOverlay: false,
            loadingOverlayText: "Loading data",
            showDetailsModal: false,
            detailsTitle: "",
            detailsContent: "",
            detailsShowChart: false,
            is_byelaw: false,

            showConditionDetails: false,
            conditionLeader: "",
            conditionReport: "",
            conditionFeatures: []
        }
    },
    methods: {
        createMap: function () {
            const map = L.map("main-map", {
                crs: L.CRS.EPSG900913,
                zoomControl: false,
                center: [52.9, -1.5],
                zoom: 7,
                layers: [MapBoxBackgroundMapping]
            })

            // createOffsetTopPlaceholders(map);

            L.control.scale({position: "bottomright"}).addTo(map);
            // map.addControl(L.control.zoom({position: "offset-topright"}));
            map.addControl(L.control.zoom({position: "bottomright"}));

            // todo: replace this with the equivalent studyAreaGeoJson as previous version to only grab clicks and show handle in relevant area
            map.on("click", function(e) {
                var coarseLatLng = reduceLatLngPrecision(e.latlng, 4);
                this.queryMap(coarseLatLng);
            }.bind(this));

            this.$store.dispatch("addMapCreateLayers", map);

        },
        queryMap: function (latLng) {
            this.loadingOverlayText = "Loading data";
            this.showLoadingOverlay = true;

            // noinspection JSUnresolvedVariable
            axios.get(mparc.urls.queryMap, {
                    params: {
                        lat: latLng.lat,
                        lng: latLng.lng
                    }
                })
                .then((returned_data) => {
                    const dataToShow = returned_data.data.leader || returned_data.data.MPAs.MCZ.length > 0 ||
                        returned_data.data.MPAs.SAC.length > 0 || returned_data.data.MPAs.SPA.length > 0 ||
                        returned_data.data.MPAs.NCMPA.length > 0 || returned_data.data.demersal_byelaws.length > 0;

                    if (!dataToShow) {
                        this.loadingOverlayText = "No data here"

                        window.setTimeout(function () {
                            this.showLoadingOverlay = false;
                        }.bind(this), mparc.shortMessageTimeout);

                        return
                    }

                    this.showLoadingOverlay = false;

                    L.popup({minWidth: 300, maxWidth: 500}).setLatLng(latLng).openOn(this.map).setContent("<div id='map-query-container'></div>");

                    // Now bind the query content Vue component to the new div created in the popup
                    // NOTE: this won't work in Vue3, but is easier, e.g:
                    // import { render, h } from "vue";
                    // const MapPopupComponent = h(MapPopup, {featureData: "text"}); // creates an instance of the component, second param is object for props
                    // render(MapPopupComponent, document.getElementById("video-popup"))  // render binds it, second param is html obj
                    const QueryContentComponent = Vue.extend(MainMapQueryContent)
                    const instance = new QueryContentComponent({propsData: {queryData: returned_data.data}})
                    instance.$mount("#map-query-container")

                    instance.$on("query-boundary", function (e) {
                        // these are click events on MPA/byelaw buttons in the component
                        this.queryBoundary(e[0], e[1]);
                    }.bind(this))  // bind the context in this component

                    this.map.panTo(latLng);
                })
                .catch((error) => {
                    if (error.response) {
                        this.loadingOverlayText = error.response.data;
                    } else {
                        this.loadingOverlayText = "Error";
                    }

                    window.setTimeout(function () {
                        this.showLoadingOverlay = false;
                    }.bind(this), mparc.shortMessageTimeout)
                })
        },
        queryBoundary: function (boundaryType, boundaryCode) {
            this.$store.dispatch("getBoundaryDetails", [boundaryType, boundaryCode])
                .then(details => {
                    this.showDetailsModal = true;
                    this.detailsTitle = details.name;
                    this.detailsContent = details.report;

                    this.is_byelaw = !!details.is_byelaw;

                    if (details.condition_info) {
                        this.conditionLeader = details.condition_info.leader;
                        this.conditionReport = details.condition_info.report;
                        this.conditionFeatures = details.condition_info.features;
                    } else {
                        this.conditionLeader = "";
                        this.conditionReport = "";
                        this.conditionFeatures = [];
                    }

                    if (details.chart_data) {
                        this.detailsShowChart = true;
                        this.$nextTick(function () {
                            const chartContainer = document.getElementsByClassName("popupFishingDataChart")[0];
                            Plotly.purge(chartContainer);
                            this.createFishingChart(details.chart_data, chartContainer);
                        })
                    }

                })
                .catch(error => {
                    this.showDetailsModal = true;
                    this.detailsTitle = "Error";
                    this.detailsContent = error;
                });
        },
        createFishingChart: function (chartData, chartContainer) {
            let chartWidth = chartContainer.offsetWidth;
            if (chartWidth > 550) { chartWidth = 550; }

            const layout = {
                xaxis: {
                    title: "Year",
                    tickmode: "linear",
                    dtick: 1,
                    automargin: true
                },
                yaxis: {
                    title: "Hours fished in MPA",
                    automargin: true
                },
                margin: {t: 60, r: 5, b: 5, l: 5, pad: 4},
                width: chartWidth,
                height: 350,
                title: "Fishing effort from Global Fishing Watch data",
                showlegend: false
            }

            const yearDesignated = chartData.designation_year;

            if (yearDesignated >= 2015) {
                let maxY = Math.max.apply(Math, chartData.trace1.y.concat(chartData.trace2.y))

                layout["shapes"] = [{
                    type: "line",
                    x0: yearDesignated,
                    y0: 0,
                    x1: yearDesignated,
                    y1: maxY,
                    line: {
                        color: "grey",
                        width: 1.5,
                        dash: "dash"
                    }
                }];

                layout["annotations"] = [{
                    x: yearDesignated,
                    y: maxY + maxY * 0.05,
                    text: "MPA designated",
                    showarrow: false,
                    arrowhead: 7
                }]
            }

            Plotly.newPlot(chartContainer, [chartData.trace1, chartData.trace2], layout, {responsive: true});
        }
    },
    computed: {
        browserLink: function () {
            if (window.location.hostname === "local.mpa-reality-check.org") {
                return "http://mpa.local.mpa-reality-check.org:8000/";
            } else if (window.location.hostname === "rc3.mpa-reality-check.org") {
                return "https://mpa.rc3.mpa-reality-check.org/";
            } else {
                return "https://mpa.mcsuk.org/";
            }
        },
        map: function () {
            return this.$store.state.map;
        }
    },
    watch: {},
    mounted: function () {
        this.$nextTick(function () {
            this.createMap();
        })
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";
    .main-map-container {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 300px;

        @media #{$breakpoint-lg-max} {
            left: 260px;
        }

        @media #{$breakpoint-int} {
            left: 0;
        }
    }

    #main-map {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;

        .leaflet-popup-content {
            width: 300px !important;

            @media #{$breakpoint-sm} {
                width: 500px !important;
            }
        }
    }

    .map-controls {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1000;
        pointer-events: none;

        a {
            text-decoration: none;
        }

        @media #{$breakpoint-int} {
            left: auto;
            right: 10px;

            a {
                display: block;
                text-align: right;
            }
        }

        .mobile-logos-in-map-controls {
            width: 80px;
            float: right;
            padding-right: 15px;
            display: none;

            @media #{$breakpoint-int} {
                display: block;
            }

            a {
                display: block;

                width: 80px;

                svg {
                    width: 80px;
                    height: 30px;
                }
            }

            a:last-of-type {
                margin-top: 2px;
            }
        }
    }

    //.main-map-overlay {  // todo: rename?
    //    position: absolute;
    //    display: flex;
    //    top: 0; right: 0; bottom: 0; left: 0;
    //    z-index: 1000;
    //
    //    background-color: rgba(0, 0, 0, .5);
    //
    //    > div {
    //        margin: auto;
    //    }
    //
    //    h4 {
    //        color: white;
    //        text-align: center;
    //    }
    //}

    .byelaw-table {
        font-size: 80%;
    }

    .details-content {
        font-size: 80%;

        h5 {
            font-size: 15px;
            margin-bottom: 0;
        }
    }

    .details-chart {

    }

</style>